module.exports = __webpack_public_path__ + "img/collection-diamondJewelry070Carat@2x.4ae75db.jpg";